module.exports = "/work-site/img/excel.e30aa852.jpg";